import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAbout, updateAbout, reset } from '../../features/about/aboutSlice';
import { useToast } from '../../contexts/ToastContext';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getImageUrl } from '../../utils/imageUrl';

const ManajemenTentangKami = () => {
  const dispatch = useDispatch();
  const { addToast } = useToast();
  const { about, isLoading, isSuccess, isError, message } = useSelector((state) => state.about);

  const [formData, setFormData] = useState({
    profile: '',
    vision: '',
    mission: '',
    slogan: '',
    ikapiCertificate: null
  });

  useEffect(() => {
    dispatch(getAbout());
  }, [dispatch]);

  useEffect(() => {
    if (about) {
      setFormData({
        profile: about.profile || '',
        vision: about.vision || '',
        mission: about.mission || '',
        slogan: about.slogan || '',
        ikapiCertificate: null
      });
    }
  }, [about]);

  useEffect(() => {
    if (isSuccess) {
      addToast({ type: 'success', message: 'Tentang Kami berhasil diperbarui!' });
      dispatch(reset());
    }
    if (isError) {
      addToast({ type: 'error', message: message || 'Gagal memperbarui Tentang Kami!' });
      dispatch(reset());
    }
  }, [isSuccess, isError, message, dispatch, addToast]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('profile', formData.profile);
    data.append('vision', formData.vision);
    data.append('mission', formData.mission);
    data.append('slogan', formData.slogan);
    if (formData.ikapiCertificate) {
      data.append('ikapiCertificate', formData.ikapiCertificate);
    }
    dispatch(updateAbout(data));
  };

  const handleContentChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Manajemen Tentang Kami</h1>
      </div>

      <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Slogan */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Slogan Penerbit</label>
            <input
              type="text"
              value={formData.slogan}
              onChange={(e) => setFormData((prev) => ({ ...prev, slogan: e.target.value }))}
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-dark-blue-500 focus:border-transparent"
              required
            />
          </div>

          {/* Profile */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Profil Penerbit</label>
            <ReactQuill
              theme="snow"
              value={formData.profile}
              onChange={(value) => handleContentChange('profile', value)}
              className="bg-gray-50 rounded-xl"
              modules={{
                toolbar: [
                  [{ 'header': [1, 2, 3, false] }],
                  ['bold', 'italic', 'underline', 'strike'],
                  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                  [{ 'color': [] }, { 'background': [] }],
                  ['link', 'blockquote'],
                  ['clean']
                ]
              }}
            />
          </div>

          {/* IKAPI Certificate */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Sertifikat IKAPI</label>
            {about?.ikapiCertificate && (
              <div className="mb-4">
                <img
                  src={getImageUrl(about.ikapiCertificate)}
                  alt="Sertifikat IKAPI"
                  className="max-w-md rounded-xl border border-gray-200"
                />
              </div>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setFormData((prev) => ({ ...prev, ikapiCertificate: e.target.files[0] }))}
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-dark-blue-500 focus:border-transparent"
            />
            <p className="text-sm text-gray-500 mt-2">Biarkan kosong jika tidak ingin mengubah sertifikat</p>
          </div>

          {/* Vision */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Visi</label>
            <ReactQuill
              theme="snow"
              value={formData.vision}
              onChange={(value) => handleContentChange('vision', value)}
              className="bg-gray-50 rounded-xl"
              modules={{
                toolbar: [
                  [{ 'header': [1, 2, 3, false] }],
                  ['bold', 'italic', 'underline', 'strike'],
                  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                  [{ 'color': [] }, { 'background': [] }],
                  ['link', 'blockquote'],
                  ['clean']
                ]
              }}
            />
          </div>

          {/* Mission */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Misi</label>
            <ReactQuill
              theme="snow"
              value={formData.mission}
              onChange={(value) => handleContentChange('mission', value)}
              className="bg-gray-50 rounded-xl"
              modules={{
                toolbar: [
                  [{ 'header': [1, 2, 3, false] }],
                  ['bold', 'italic', 'underline', 'strike'],
                  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                  [{ 'color': [] }, { 'background': [] }],
                  ['link', 'blockquote'],
                  ['clean']
                ]
              }}
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="px-8 py-3 bg-dark-blue-700 text-white rounded-xl font-medium hover:bg-dark-blue-800 transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Menyimpan...' : 'Simpan Perubahan'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ManajemenTentangKami;
